import { Box, useTheme } from "@mui/material";
import {
  containerStyles,
  reactionBoxStyles,
  reactionIconStyles,
} from "./styles";

type ReactionBlockProps = {
  markedIds: Record<string, string>;
  handleReactionClick: (reactionKey: string) => void;
  handleAddToFavorite: () => void;
  handleReportMessage?: () => void;
};

export const ReactionBlock = ({
  markedIds,
  handleReactionClick,
  handleAddToFavorite,
  handleReportMessage,
}: ReactionBlockProps) => {
  const theme = useTheme();
  return (
    <Box sx={containerStyles(theme)}>
      <Box sx={reactionBoxStyles(theme)}>
        {Object.entries(markedIds).map(([key, emoji]) => (
          <Box
            key={key}
            component="span"
            sx={reactionIconStyles(theme)}
            onClick={() => handleReactionClick(key)}
            onMouseDown={(e) => e.stopPropagation()}
          >
            {emoji}
          </Box>
        ))}
        <Box
          component="span"
          sx={reactionIconStyles(theme)}
          onClick={() => handleAddToFavorite()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          ⭐️
        </Box>
        {handleReportMessage && (
          <Box
            component="span"
            title="Report a message"
            sx={reactionIconStyles(theme)}
            onClick={handleReportMessage}
            onMouseDown={(e) => e.stopPropagation()}
          >
            ⚠️
          </Box>
        )}
      </Box>
    </Box>
  );
};
